import { render, staticRenderFns } from "./owner.vue?vue&type=template&id=3e94049b&"
import script from "./owner.vue?vue&type=script&lang=js&"
export * from "./owner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports